<template>
  <ModalCardDefault
    :title="`Empresa — ${company.name || ''}`"
    @close="$emit('close')"
  >
    <ExpansionPanel
      v-model="mainPanel"
      title="Dados Principais"
      :icon="$icons.accountTie"
      readonly
    >
      <Row>
        <Col cols="12" md="6">
          <strong>Nome:</strong> {{ company.name || '-' }}
        </Col>
        <Col cols="12" md="6">
          <strong>Razão Social:</strong> {{ company.social_name || '-' }}
        </Col>
        <Col cols="12" md="4">
          <strong>CNPJ:</strong> {{ formatCnpj(company.cnpj) }}
        </Col>
        <Col cols="12" md="4">
          <strong>Inscrição Estadual:</strong> {{ company.ie || '-' }}
        </Col>
        <Col cols="12" md="4">
          <strong>Inscrição Municipal:</strong> {{ company.im || '-' }}
        </Col>
        <Col cols="12" md="4">
          <strong>IE ST:</strong> {{ company.ie_st || '-' }}
        </Col>
        <Col cols="12" md="4">
          <strong>Suframa:</strong> {{ company.suframa || '-' }}
        </Col>
        <Col cols="12" md="4">
          <strong>Cliente:</strong> {{ company.customer?.name || '-' }}
        </Col>
      </Row>
    </ExpansionPanel>

    <ExpansionPanel
      v-model="fiscalPanel"
      title="Dados Fiscais"
      :icon="$icons.fileDocumentCheckOutline"
      readonly
      class="mt-4"
    >
      <Row>
        <Col cols="12" md="6">
          <strong>Regime Tributário:</strong> {{ getTaxRegimeLabel(company.tax_regime) }}
        </Col>
        <Col cols="12" md="3">
          <strong>CNAE:</strong> {{ company.cnae || '-' }}
        </Col>
        <Col cols="12" md="3">
          <strong>Código de Atividade:</strong> {{ company.activity_code || '-' }}
        </Col>
      </Row>
    </ExpansionPanel>

    <ExpansionPanel
      v-model="contactPanel"
      title="Dados de Contato"
      :icon="$icons.cellPhone"
      readonly
      class="mt-4"
    >
      <Row>
        <Col cols="12" md="4">
          <strong>Contato:</strong> {{ company.contact_name || '-' }}
        </Col>
        <Col cols="12" md="4">
          <strong>E-mail:</strong> {{ company.email || '-' }}
        </Col>
        <Col cols="12" md="4">
          <strong>Celular:</strong> {{ company.cell_phone || '-' }}
        </Col>
      </Row>
    </ExpansionPanel>

    <ExpansionPanel
      v-if="company.address"
      v-model="addressPanel"
      title="Endereço"
      :icon="$icons.address"
      readonly
      class="mt-4"
    >
      <Row>
        <Col cols="12" md="3">
          <strong>CEP:</strong> {{ company.address.zip_code || '-' }}
        </Col>
        <Col cols="12" md="6">
          <strong>Logradouro:</strong>
          {{ company.address.street || '-' }}, {{ company.address.number || 'S/N' }}
        </Col>
        <Col cols="12" md="3">
          <strong>Complemento:</strong> {{ company.address.complement || '-' }}
        </Col>
        <Col cols="12" md="4">
          <strong>Bairro:</strong> {{ company.address.neighborhood || '-' }}
        </Col>
        <Col cols="12" md="4">
          <strong>Cidade:</strong> {{ company.address.city || '-' }}
        </Col>
        <Col cols="12" md="4">
          <strong>UF:</strong> {{ company.address.uf || '-' }}
        </Col>
      </Row>
    </ExpansionPanel>
  </ModalCardDefault>
</template>

<script>
import ModalCardDefault from '@/components/ModalCardDefault';
import { ExpansionPanel, Row, Col } from '@/components/vuetify';
import { formatCpfCnpj } from '@/utils';
import { typeTaxRegime } from '@/utils/options';

export default {
  name: 'AdminCompanyDetailsModal',
  components: {
    ModalCardDefault,
    ExpansionPanel,
    Row,
    Col,
  },
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mainPanel: [0],
      fiscalPanel: [0],
      contactPanel: [0],
      addressPanel: [0],
    };
  },
  methods: {
    formatCnpj(value) {
      return value ? formatCpfCnpj(value) : '-';
    },
    getTaxRegimeLabel(value) {
      return typeTaxRegime.find((item) => item.value === value)?.text || value || '-';
    },
  },
};
</script>
